import Api from "./api.page";

export default Api;
